<template>
  <div>
    <div class="checkbox-block">
      <input
        type="checkbox"
        :name="this.field.metadata.fieldName"
        :required="this.field.metadata.required"
        :id="id"
        :data-nextCheckboxID="(count+1)"
      />
      <label :for="id">
        <span class="required" v-if="this.field.metadata.required">*</span>
        {{ this.field.metadata.content }}
      </label>
    </div>
    <div class="hint" v-if="this.field.metadata.hint">
      <span v-html="this.field.metadata.hint"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormCheckbox",
  props: {
    field: {
      type: Object,
    },
  },
  data() {
    return {
      id: null,
      count: 0,
    };
  },
  beforeMount() {
    const ID_PREFIX = "form-checkbox";
    const checkboxes = document.querySelectorAll("input[data-nextCheckboxID]");
    if (checkboxes.length <= 0) {
      this.count = 1;
    } else {
      this.count = checkboxes[checkboxes.length-1].dataset.nextcheckboxid;
    }
    this.id = `${ID_PREFIX}-${this.count}`;
  },
};
</script>

<style scoped>
.checkbox-block {
  display: flex;
  align-items: center;
}

.checkbox-block > input {
  width: 16px;
  height: 16px;  
}

.checkbox-block > label {
  padding-left: 10px;
}

.hint {
  color: #8a8a8a;
  margin-left: 5px;
  margin-top: 5px;
}

.hint >>> * {
  margin-top: 0;
  margin-bottom: 0;
}

.required {
  color: #f00;
}
</style>